import { ReactComponent } from "./arrow-left-right-line.svg";

interface Props {
  fill?: string;
  width?: string;
  height?: string;
}

const ArrowLeftRightLineIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default ArrowLeftRightLineIcon;
